import React from 'react';
import { Radio, Form } from 'antd';
import { getIn } from 'formik';
import PropTypes from 'prop-types';

const RadioGroup = props => {
  const { form, field, label, options } = props;

  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);
  const hasError = error !== undefined && touched;
  const isValid = !error && !!touched;

  const { name, onChange, onBlur, value } = field;

  const renderOptions = () => {
    return options.map(({ label, value: optionValue }) => (
      <Radio
        key={optionValue}
        name={name}
        type="radio"
        value={optionValue}
        checked={value === optionValue}
        onChange={onChange}
        onBlur={onBlur}
      >
        {label}
      </Radio>
    ));
  };

  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      <Radio.Group name={name}>{renderOptions()}</Radio.Group>
    </Form.Item>
  );
};
RadioGroup.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  options: PropTypes.array,
  label: PropTypes.string
};
export default RadioGroup;
